<template>
  <ion-page id="repmanager-page">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
              @alert-result="alertResult"></AlertReplacement>

    <ion-content >
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleRepertoireManger">
        <div style="text-align:center">
          <h2>{{ title }}</h2>
        </div>
 
        <RepManagerAgGrid :repertoireList="repertoireList" 
              :repertoireListTrigger="repertoireListTrigger" 
              :isExport="isExport"
              :styleHeight="styleRepertoireMangerAgHeight"
              @field-value-changed="repertoireFieldValueChanged"
              @selected-click="repertoireSelectedClick"/>
      </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                        @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

  import { IonAlert, IonButton,IonPage, IonContent, modalController } from '@ionic/vue';

  import Toolbar from '@/components/Toolbar.vue';
  import { t } from '@/composables/translateText.js'

  import ModalAddEditRepertoire from '@/components/ModalAddEditRepertoire.vue'
  import AlertReplacement from '@/components/AlertReplacement.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import RepManagerAgGrid from '@/components/RepManagerAgGrid.vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { watch, onMounted, ref } from "vue";

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData, useGetDataDownload } from '@/composables/getData.js'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  const alertInfo = ref({})
  const alertTrigger = ref(0)
  const toolbarTrigger = ref(0)

  const connectionStore = useConnectionStore()
  var explorerType = connectionStore.getProductOption
  
  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  // TESTING
  //explorerType = "export"

  const isExport = ref(explorerType == "export")
  const repertoireListTrigger = ref(0)

  const title = ref("Repertoire List")
  const menuName = ref((isExport.value) ? "Export" : "Manager")

  // for add/edit

  var minRating = 1300
  var maxRating = 1700

  var addName = ""
  var addColor = "white"
  var editPercentage = 1
  const addPercentageFilter = ref("6")

  // end for add

  // track the current id stored on the server so don't update if the same
  var currentRepertoireId = 0
  var repertoireIdMap = new Map()

  const tourTrigger = ref(0)
  const showTour = ref(false)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const TOOLBAR_ADD = 0
  const TOOLBAR_EDIT = 1
  const TOOLBAR_COPY = 2
  const TOOLBAR_DELETE = 3

  const toolbarElements = ref([])

  const toolbarManagerElements = [
    { index : TOOLBAR_ADD, label : t("Add") ,disabled : false,collapse:false},
    { index : TOOLBAR_EDIT, label : t("Edit") ,disabled : true,collapse:false},
    { index : TOOLBAR_COPY, label : t("Copy") , disabled : true,collapse:false},
    { index : TOOLBAR_DELETE, label : t("Delete") , disabled : true,collapse:false},
  ]
 
  const TOOLBAR_DOWNLOAD = 10
  const TOOLBAR_DOWNLOAD_SET = 11
  const TOOLBAR_DOWNLOAD_CLEAR = 12

  const toolbarDownloadElements = [
    { index : TOOLBAR_DOWNLOAD, label : t("Download") ,disabled : false,collapse:false},
    { index : TOOLBAR_DOWNLOAD_SET, label : t("Select-All") , disabled : false,collapse:false},
    { index : TOOLBAR_DOWNLOAD_CLEAR, label : t("Clear") , disabled : false,collapse:false}
    ]
 
  toolbarElements.value = toolbarManagerElements

  const repertoireList = ref([])
   // tour stuff

   const tourInfo = ref({
    id : "opening_slicedice",
    elements : [
      { id: "", title: "Explore", text : "Why are we deciding our opening moves based on how the game ends 40 to 60 moves later?<br><br>That's an unfair burden for the game's first few moves."},
      { id: "", title: "There Is A Better Way!", text : "Chess Opening Mastery is a game changing, data driven approach to evaluating the game's first moves.<br><br>"},
      { id: "", title: "A Window into the Middle Game", text : "Chess Opening Mastery's revolutionary approach shows how the games are progressing in the middle game.<br><br>How? For every game, the Stockfish computer engine has been used to evaluate the position before white's moves 12, 15, 18 and 21. Stockfish scores each board as having an advantage for white (positive numbers) or an advantage for black (negative numbers)." },
      { id: "", title: "Stockfish Scores", text : "You probably know that a pawn is worth 1 point, a bishop/knight is worth 3 and a rook is 5 points. Stockfish reports back a position as being the equivalent of 'up' some number of pawns.<br><br>The bar chart shows that distribution for games start with the given move sequence."},
      { id: "", title: "The Game Collection", text : "The Lichess 'rapid' games were used to build the tree. With a unique twist - only games where the players are within the same 50 point 'bucket' are included.<br><br>Why? Because even a 50 point difference between two players gives the higher rated player a 6% win advantage which swamps any advantage that can be obtained by a particular opening."},
      { id: "the_tree", title: "The Graph", text : "The graph shows the distribution of the Stockfish engine scores for games where the checked move(s) was made.<br><br>For example, if '1.e4' is checked and the slider is at move 15 then the graph shows how well players who played 'e4' are doing in their games at move 15."},
      { id: "the_tree", title: "The Bars", text : "The bars show the percentage of games in each bucket. The buckets start on the left with black having already won the game by the future move number. Next to that is the percentage of games where black has a 'huge' advantage"},
      { id: "the_tree", title: "The Point Bars", text : "The next several bars break the stockfish engine scores into one point buckets.<br><br><i>(The 3 point bucket represents being up a bishop and the 1 point bucket represents being up by a pawn.)</i>"},
      { id: "the_tree", title: "The Middle &amp; White's Bars", text : "The center bar shows the percentage of games that are about even.<br><br>The bars to the right are white's mirroring the black buckets from 1 point through already won games."},
      { id: "the_toolbar", title: "Options", text : "Used to set the rating range and color."},
    ]
  })

  const styleRepertoireMangerAgHeight = ref("height: 300px")

  const styleRepertoireManger = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  // YES, NO alert
 
  function alertResult(response,task,info) {
    //console.log("Alert Result",response,task,info.payload)

    if (response == "no")
      return

    const selectedId = info.payload
    const selectedRepertoire = repertoireIdMap.get(selectedId)

    switch (task) {
    case "copy" :
      const currentName = selectedRepertoire.name
      const uniqueName = makeUniqueRepertoireName(currentName)
      copyRepertoire(currentRepertoireId,uniqueName)
      break
    case "delete" :
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EDIT,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COPY,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_DELETE,true)
      toolbarTrigger.value++
      deleteRepertoire(currentRepertoireId)
      break
    }
  }
  
  // ADD Modal
  const addEditRepertoireModal = async (action) => {
    const modal = await modalController.create({
      component: ModalAddEditRepertoire,
      componentProps: {
        action : action,
        min : minRating,
        max : maxRating,
        color : addColor,
        name : addName,
        editPercentage : editPercentage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      if (action == "add") {
        const uniqueName = makeUniqueRepertoireName(data.name)
        addRepertoire(uniqueName,data.min,data.max,data.percent,data.color)
      }
      else {
        const selectedRepertoire = repertoireIdMap.get(currentRepertoireId)
      

        if (selectedRepertoire.minrating == data.min && selectedRepertoire.maxrating == data.max &&
            selectedRepertoire.percentageNumber == data.editPercentage && 
            selectedRepertoire.name == data.name)
          return

        if (data.name != selectedRepertoire.name)
          data.name = makeUniqueRepertoireName(data.name)
        editRepertoireFields(currentRepertoireId,data.name,data.min,data.max,data.editPercentage)
      }
    }
  };

  function resetScreen() {
    isExport.value = (explorerType == "export")
    title.value = (isExport.value) ? t("Select For Export") : t("Repertoire List")
    menuName.value = (isExport.value) ? "Export" : "Manager"

    toolbarElements.value = (isExport.value) ? toolbarDownloadElements : toolbarManagerElements
    toolbarTrigger.value++
    //repertoireListTrigger.value++
  }

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    if (connectionStore.getIsSubscriber != 1) {
      return
    }
    resetScreen()
    updateWidthHeights()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  onMounted(() => {
    getRepertoires()
   })

   watch(() => connectionStore.getProductOption, () => {
    explorerType = connectionStore.getProductOption
    resetScreen()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  // FOR ADD

  function updateValues(e) {
    barMinValue.value = e.minValue;
    barMaxValue.value = e.maxValue;   
    if (barMaxValue.value == barMinValue.value) {
      if (barMinValue.value < barMax.value)
        barMaxValue.value = barMinValue.value + 50
      else
        barMinValue.value = barMaxValue.value - 50
    }
  }

  function setSliderValues() {
    if (barMaxValue.value > barMax.value)
      barMaxValue.value = barMax.value
    if (barMinValue.value < barMin.value)
      barMinValue.value = barMin.value
  }

  function moveNumberChange(e) {
  }

  // END FOR ADD
  function repertoireSelectedClick(repertoireId) {
    //console.log("selected repertoire",repertoireId)
    if (repertoireId != currentRepertoireId) {
      currentRepertoireId = repertoireId
      updateSelectedRepertoireId(repertoireId)
    }
  }

  function repertoireFieldValueChanged(repertoireId,fieldName,value) {
    //console.log("field in repertoire changed",repertoireId,fieldName,value)
    updateRepertoireField(repertoireId,fieldName,value)
  }

  function toolbarClick(index) {
    var i = 0
    var selectedRepertoire = {}
    var answer = false
    const element = findToolbarElement(toolbarElements.value,index)
    if (element.disabled)
      return

    switch (index) {
      case TOOLBAR_DOWNLOAD :
        getDownload()
        break
      case TOOLBAR_DOWNLOAD_SET :
        for (i=0; i < repertoireList.value.length; i++)
          repertoireList.value[i].export = 1
        repertoireListTrigger.value++
        updateRepertoireField(0,"exportall",1)
        break
      case TOOLBAR_DOWNLOAD_CLEAR :
        for (i=0; i < repertoireList.value.length; i++)
          repertoireList.value[i].export = 0
        repertoireListTrigger.value++
        updateRepertoireField(0,"exportnone",0)
        break
      case TOOLBAR_ADD :
        addEditRepertoireModal("add")
        break
      case TOOLBAR_EDIT :
        selectedRepertoire = repertoireIdMap.get(currentRepertoireId)
        if (selectedRepertoire != null && selectedRepertoire.locked == 1) {
          //setupAlert("Cannot Delete","The selected repertoire is 'LOCKED'","alert")
          break
        }
        minRating = selectedRepertoire.minrating
        maxRating = selectedRepertoire.maxrating
        addColor = selectedRepertoire.color.toLowerCase()
        addName = selectedRepertoire.name
        editPercentage = selectedRepertoire.percentageNumber
        addEditRepertoireModal("edit")
        break
      case TOOLBAR_DELETE :
        selectedRepertoire = repertoireIdMap.get(currentRepertoireId)
        if (selectedRepertoire != null && selectedRepertoire.locked == 1) {
          //setupAlert("Cannot Delete","The selected repertoire is 'LOCKED'","alert")
          break
        }
        alertInfo.value = { header : t("Delete Repertoire?"), message : t("Do you want to delete the selected repertoire?"), type : "yesno", task : "delete" , 
                        payload : currentRepertoireId }
        alertTrigger.value++
        break
      case TOOLBAR_COPY :
        selectedRepertoire = repertoireIdMap.get(currentRepertoireId)
        if (selectedRepertoire == null)
          break
        alertInfo.value = { header : t("Copy Repertoire?"), message : t("Do you want to copy the selected repertoire?"), type : "yesno", task : "copy" , 
                        payload : currentRepertoireId }
        alertTrigger.value++
        break
    }
  }

  function updateStyleObjects(boundaries) {
    styleRepertoireManger.value.height = boundaries['repmanager'].height + "px"
    styleRepertoireManger.value.width = boundaries['repmanager'].width + "px"
    styleRepertoireManger.value.top = boundaries['repmanager'].top + "px"
    styleRepertoireManger.value.left = boundaries['repmanager'].left + "px"

    styleRepertoireMangerAgHeight.value = "height: " + (boundaries['repmanager'].height-boundaries['repmanager'].top) + "px"

  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const repManagerPositionTop = 0
    const repManagerPositionLeft = availableSpace.leftRightIndent 
    const repManagerHeight = availableSpace.height - repManagerPositionTop
    const repManagerWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { repmanager : {
        width : repManagerWidth,
        height : repManagerHeight,
        left : repManagerPositionLeft + availableSpace.leftIndent,
        top : repManagerPositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }

  function tourDone() {
    showTour.value = false
  }

  // returns unique name among repertoires
  function makeUniqueRepertoireName(name) {
    // this for copying an existing repertoire, so we know original name already exists
    var loop = 0
    while (true) {
      var value = name
      if (loop > 0)
        value += " (" + loop + ")"
      for (var i=0; i < repertoireList.value.length; i++) {
        const oneRow = repertoireList.value[i]
        if (oneRow.name == value) {
          loop++
          break
        }
      }
      if (i == repertoireList.value.length)
        break
    }
    return (value)
  }

  function jsonError(text) {
    alertInfo.value = { header : "Error", message : text, type : "error", task : "json" }
    alertTrigger.value++
  }

  function processRepertoiresJsonResponse(json) {
    //console.log("repertoires json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    currentRepertoireId = json['currentid']
    const count = parseInt(json['count'])
    const ids = json['ids'].split("\t")
    const names = json['names'].split("\t")
    const colors = json['colors'].split("\t")
    const drills = json['drills'].split("\t")
    const exports = json['exports'].split("\t")
    const mins = json['mins'].split("\t")
    const maxs = json['maxs'].split("\t")
    const percents = json['percents'].split("\t")
    const locks = json['locks'].split("\t")
    const times = json['times'].split("\t")

    repertoireList.value = []
    repertoireIdMap.clear()

    for (var i=0; i < count; i++) {
      const oneRepertoire = { id : ids[i], 
                            export : exports[i],
                            drill : drills[i],
                            color : (colors[i] == "w") ? "White" : "Black",
                            name : names[i],
                            minrating : parseInt(mins[i]),
                            maxrating : parseInt(maxs[i]),
                            percentage : (parseInt(percents[i]) / 10000.0) + "%",
                            percentageNumber : (parseInt(percents[i]) / 10000.0),
                            locked : locks[i],
                            date : times[i],
                            selected : (ids[i] == currentRepertoireId)
                          }
      repertoireList.value.push(oneRepertoire)
      repertoireIdMap.set(ids[i],oneRepertoire)
    }
    repertoireListTrigger.value++

    const selectedRepertoire = repertoireIdMap.get(currentRepertoireId)

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EDIT,(selectedRepertoire != null) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COPY,(selectedRepertoire != null) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_DELETE,(selectedRepertoire != null && 
                    selectedRepertoire.locked != 1) ? false : true)
    toolbarTrigger.value++
  }

  function getRepertoires() {
    const timeNow = Math.floor(Date.now() / 1000)

    const formData = {
      time : timeNow
    }

    useGetData("chessvis_repertoire_get_repertoires.php", formData, processRepertoiresJsonResponse)
  }


  function processUpdateSelectedJsonResponse(json) {
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    const selectedRepertoire = repertoireIdMap.get(currentRepertoireId)

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EDIT,(selectedRepertoire != null) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COPY,(selectedRepertoire != null) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_DELETE,(selectedRepertoire != null && 
                    selectedRepertoire.locked != 1) ? false : true)
    toolbarTrigger.value++
  }

  function updateSelectedRepertoireId(repertoireId) {

    var formData = { 
      repid : repertoireId
    }
    useGetData("chessvis_repertoire_update_repertoireid.php", formData, processUpdateSelectedJsonResponse)
  }

  function processUpdateFieldJsonResponse(json) {
    //console.log("repertoires update json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }

    if (isExport.value == false) {
      const selectedRepertoire = repertoireIdMap.get(currentRepertoireId)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EDIT,(selectedRepertoire != null) ? false : true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COPY,(selectedRepertoire != null) ? false : true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_DELETE,(selectedRepertoire != null && 
                      selectedRepertoire.locked != 1) ? false : true)
      toolbarTrigger.value++
    }
  }

  function updateRepertoireField(repertoireId,fieldName,value) {

    var formData = { 
      repid : repertoireId,
      name : fieldName,
      value : value
    }
    //console.log("formdata in update repertoire field",formData)
    useGetData("chessvis_repertoire_update_field.php", formData, processUpdateFieldJsonResponse)
  }

  function processEditFieldsJsonResponse(json) {
    //console.log("repertoires edit fields json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
  
    getRepertoires()
  }

  function editRepertoireFields(repertoireId,fieldName,minrating,maxrating,percentage) {

    var formData = { 
      repid : repertoireId,
      name : fieldName,
      minrating : minrating,
      maxrating : maxrating-1,
      percentage : percentage
    }
    //console.log("formdata in edit repertoire fields",formData)
    useGetData("chessvis_repertoire_edit_fields.php", formData, processEditFieldsJsonResponse)
  }

  function processCopyJsonResponse(json) {
    //console.log("repertoires copy json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
    const newId = parseInt(json['new'])
    if (newId == 0) {
      //setupAlert("Error","There was a problem in copying the repertoire. Please contact henry@chessvis.com","alert")
      return
    }
    getRepertoires()
  }

  function copyRepertoire(repertoireId,newName) {

    var formData = { 
      repid : repertoireId,
      new_name : newName,
      backup : "no"
    }
    //console.log("formdata in copy repertoire field",formData)
    useGetData("chessvis_repertoire_manager_copy.php", formData, processCopyJsonResponse)
  }

  function processDeleteJsonResponse(json) {
    //console.log("repertoires delete json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
    getRepertoires()
  }

  function deleteRepertoire(repertoireId) {

    var formData = { 
      repid : repertoireId,
    }
    //console.log("formdata in delete repertoire field",formData)
    useGetData("chessvis_repertoire_manager_delete.php", formData, processDeleteJsonResponse)
  }

  function processAddJsonResponse(json) {
    //console.log("repertoires add json callback",json)
    if (json.hasOwnProperty('error')) {
      jsonError("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
      return;
    }
    const newId = parseInt(json['new'])
    if (newId == 0) {
      //setupAlert("Error","There was a problem in adding the repertoire. Please contact henry@chessvis.com","alert")
      return
    }
    getRepertoires()
  }

  function addRepertoire(name,ratingMin,ratingMax,percentage,color) {

    const playingWhite = (color == "white") ? 1 : 0

    var formData = { 
      name : name,
      rating_min : ratingMin,
      rating_max : ratingMax - 1,
      percentage : percentage,
      playing_white : playingWhite
    }
    //console.log("formdata in add repertoire field",formData)
    useGetData("chessvis_repertoire_manager_add.php", formData, processAddJsonResponse)
  }

  function getDownload() {
    const timeNow = Math.floor(Date.now() / 1000)

    const formData = {
      time : timeNow,
      onerep : 0
    }

    useGetDataDownload("chessvis_repertoire_opening_export.php", formData)
  }

</script>

<style scoped>

</style>